import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/auth';
import SplashScreen from './SplashScreen';

const LoginRoute: React.FC = () => {
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <SplashScreen />;
};

export default LoginRoute;
